module.exports = __webpack_public_path__ + "static/media/swingntonic.13f10b43.mp3";